module.exports = __webpack_public_path__ + "static/media/CH-VD.f5d49b1c.geojson";